/**
 * Single source of truth for Open Graph share images.
 * Files live in /public/og/*.jpg (1200x630), generated by
 * backend/scripts/generate_og_images.py — regenerate there, never hand-edit.
 */
export const SITE_URL = "https://yastikmedya.com";

const KNOWN = new Set([
  "home", "home-en", "services", "meta-ads", "google-ads", "seo", "social-media",
  "web-development", "creative", "postun-hazir", "blog", "about", "works", "contact", "paketini-bul",
]);

export function ogImageUrl(key, lang = "tr") {
  if (key === "home" && lang !== "tr" && KNOWN.has("home-en")) return `${SITE_URL}/og/home-en.jpg`;
  const safe = KNOWN.has(key) ? key : "home";
  return `${SITE_URL}/og/${safe}.jpg`;
}

export const DEFAULT_OG_IMAGE = ogImageUrl("home");
